module.exports = __webpack_public_path__ + "media/images/short_scenario_contest/triangle-orange-9b6578452b3e549fba78c7ee70ee0a4e.png";